import type { WalkthroughConfig } from "../types";

export const masterOverviewWalkthrough: WalkthroughConfig = {
  id: "master-overview",
  title: "Welcome to MemberOS",
  description: "Discover how MemberOS helps you attract, engage, and retain members.",
  type: "overview",
  duration: "3 min",
  category: "getting-started",
  icon: "Rocket",
  steps: [
    {
      id: "welcome",
      title: "Welcome to MemberOS",
      description:
        "MemberOS is the operating system for membership organizations. It connects every part of your member lifecycle — from acquisition to retention — in one integrated platform.",
      placement: "center",
      animation: "scale",
      icon: "Rocket",
      isChapter: true,
      nextLabel: "Let's explore →",
    },
    {
      id: "ecosystem",
      title: "The MemberOS Ecosystem",
      description:
        "MemberOS works alongside TribeSpring (community & networking) and Bullseye (member development & assessment) to deliver a complete member experience platform.",
      placement: "center",
      animation: "fade",
      icon: "Network",
    },
    {
      id: "acquire",
      title: "Acquire New Members",
      description:
        "Use Website Builder, Campaign Funnels, and public event registration to attract prospects and convert them into members with streamlined application and onboarding flows.",
      placement: "center",
      animation: "slide-up",
      icon: "UserCheck",
    },
    {
      id: "activate",
      title: "Activate Members Fast",
      description:
        "Automated onboarding campaigns, welcome wizards, and member success milestones ensure every new member gets immediate value from day one.",
      placement: "center",
      animation: "slide-up",
      icon: "Rocket",
    },
    {
      id: "engage",
      title: "Drive Deep Engagement",
      description:
        "Events, Signature Events, Programming Calendar, Cohorts, Committees, and Communications keep your members actively participating and connected.",
      placement: "center",
      animation: "slide-up",
      icon: "Activity",
    },
    {
      id: "retain",
      title: "Retain & Grow",
      description:
        "Renewal intelligence, engagement scoring, at-risk detection, and automated re-engagement help you prevent churn before it happens.",
      placement: "center",
      animation: "slide-up",
      icon: "TrendingUp",
    },
    {
      id: "prove-value",
      title: "Prove Your Value",
      description:
        "Board reports, ROI dashboards, and member success metrics give you and your board the data to demonstrate the impact of membership.",
      placement: "center",
      animation: "slide-up",
      icon: "BarChart3",
    },
    {
      id: "dashboard",
      title: "Your Command Center",
      description:
        "The Dashboard gives you a real-time view of member health, upcoming events, engagement trends, and action items — everything you need at a glance.",
      placement: "center",
      animation: "fade",
      icon: "LayoutDashboard",
    },
    {
      id: "ready",
      title: "You're Ready!",
      description:
        "Explore each module at your own pace. Look for the help button (?) on any page to get context-specific guidance. Let's build something great together.",
      placement: "center",
      animation: "scale",
      icon: "Trophy",
      isChapter: true,
      nextLabel: "Get started! 🎉",
    },
  ],
};
